import React from 'react';
import { useNavigate } from 'react-router-dom';
import './DetailsNotesModal.css';
import { ReactComponent as CloseIcon } from "../../assets/icons/close.svg";

interface DetailsNotesModalProps {
  isOpen: boolean;
  onClose: () => void;
  critereOrganisation: {
    note: number;
    commentaire: string;
    description?: string;
  };
  critereMoyen: {
    note: number;
    commentaire: string;
    description?: string;
  };
  critereSocial: {
    note: number;
    commentaire: string;
    description?: string;
  };
}

const DetailsNotesModal: React.FC<DetailsNotesModalProps> = ({
  isOpen,
  onClose,
  critereOrganisation,
  critereMoyen,
  critereSocial
}) => {
  if (!isOpen) return null;

  return (
    <div className="details-notes-overlay">
      <div className="details-notes-modal">
        <div className="modal-header">
          <h2>Détails de la note</h2>
          <hr className="darkblue"/>
          <button className="close-button" onClick={onClose}>
            <svg xmlns="http://www.w3.org/2000/svg" width="38" height="38" viewBox="0 0 38 38" fill="none">
              <circle cx="19" cy="19" r="19" fill="#2C3948"/>
              <path d="M13 13L25 25M25 13L13 25" stroke="#FFFDFC" strokeWidth="3.5" strokeLinecap="round"/>
            </svg>
          </button>
        </div>
        <div className="criteres-container">
          {/* Critère Organisation */}
          <div className="critere-block">
            <div className="critere-colone-1">
              <div className="critere-titre">
                <h3>Critère Organisation</h3>
                <div className="note-container">
                  <span className="note">{critereOrganisation.note}</span>
                  <span className="separator">/</span>
                  <span className="total">10</span>
                </div>
              </div>
              <div className="score-bar">
                <div
                  className="score-fill green"
                  style={{width: `${(critereOrganisation.note/10) * 100}%`}}
                />
              </div>
            </div>
            <div className="critere-colone-2">
              <p className="commentaire">{critereOrganisation.commentaire}</p>
              {critereOrganisation.description && (
                <div className="description-prestataire">
                  <p>Description du prestataire</p>
                  <p className="description-text">{critereOrganisation.description}</p>
                </div>
              )}
              <div className="commentaire-centralis">
                <p>Commentaire de Centralis</p>
                <div className="info-circle">i</div>
              </div>
            </div>
          </div>

          {/* Critère Moyen */}
          <div className="critere-block">
            <div className="critere-colone-1">
              <div className="critere-titre">
                <h3>Critère Moyen</h3>
                <div className="note-container">
                  <span className="note">{critereMoyen.note}</span>
                  <span className="separator">/</span>
                  <span className="total">10</span>
                </div>
              </div>
              <div className="score-bar">
                <div
                  className="score-fill orange"
                  style={{width: `${(critereMoyen.note/10) * 100}%`}}
                />
              </div>
            </div>
            <div className="critere-colone-2">
              <p className="commentaire">{critereMoyen.commentaire}</p>
              {critereMoyen.description && (
                <div className="description-prestataire">
                  <p>Description du prestataire</p>
                  <p className="description-text">{critereMoyen.description}</p>
                </div>
              )}
              <div className="commentaire-centralis">
                <p>Commentaire de Centralis</p>
                <div className="info-circle">i</div>
              </div>
            </div>
          </div>

          {/* Critère Social/Environnement */}
          <div className="critere-block">
            <div className="critere-colone-1">
              <div className="critere-titre">
                <h3>Critère Social/Environnement</h3>
                <div className="note-container">
                  <span className="note">{critereSocial.note}</span>
                  <span className="separator">/</span>
                  <span className="total">10</span>
                </div>
              </div>
              <div className="score-bar">
                <div
                  className="score-fill green"
                  style={{width: `${(critereSocial.note/10) * 100}%`}}
                />
              </div>
            </div>
            <div className="critere-colone-2">
              <p className="commentaire">{critereSocial.commentaire}</p>
              {critereSocial.description && (
                <div className="description-prestataire">
                  <p>Description du prestataire</p>
                  <p className="description-text">{critereSocial.description}</p>
                </div>
              )}
              <div className="commentaire-centralis">
                <p>Commentaire de Centralis</p>
                <div className="info-circle">i</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsNotesModal;